<cigna-skeleton
  *ngIf="lastName === ''; else utilUser"
  repeat="1"
  layout="10"
  class="nav-skeleton"
>
</cigna-skeleton>

<ng-template #utilUser>
  <div class="util-user" data-test-id="profile-nav" cignaHoverDropdown>
    <button cignaButton="link" class="header-link">
      <cigna-icon type="profile-head" class="util-user__img"></cigna-icon>
      <span class="util-user__name" data-test-id="header-user-name"
        >{{ firstName }} {{ lastName }}</span
      >
      <cigna-icon type="caret-down" class="util-dropdown"></cigna-icon>
    </button>

    <div class="util-user__links" #dropdownMenu>
      <div class="util-user__link-item util-user__link-item--static">
        Signed in as (<span cg-test="userid" data-test-id="header-user-id">{{
          userid
        }}</span
        >)
      </div>

      <ng-container *ngFor="let link of profileLinks">
        <ng-container *ngIf="!link.openExternal; else externalLink">
          <a
            [href]="link.path"
            [routerLink]="link.path"
            class="util-user__link-item util-user__link-item--clickable"
            [class.cg-disabled-link]="isImpersonator && !link.allowImpersonator"
            [class.cg-non-clickable]="isImpersonator && !link.allowImpersonator"
            [attr.data-test-id]="'profile-nav-child-' + link.identifier"
            [cignaTrackClicks]="[
              'trackEventOther',
              link.title,
              'ac-NV002-Name Subnav',
              { prop20: 'nav-sub-utility' }
            ]"
            >{{ link.title }}</a
          >
        </ng-container>

        <ng-template #externalLink>
          <a
            class="util-user__link-item util-user__link-item--clickable"
            cg-disabled-link
            [href]="link.path"
            target="_blank"
            rel="noopener noreferrer"
            [class.cg-disabled-link]="isImpersonator && !link.allowImpersonator"
            [class.cg-non-clickable]="isImpersonator && !link.allowImpersonator"
            [attr.data-test-id]="'profile-nav-child-' + link.identifier"
            [cignaTrackClicks]="[
              'trackEventOther',
              link.title,
              'ac-NV002-Name Subnav',
              { prop20: 'nav-sub-utility' }
            ]"
            >{{ link.title }}
            <cigna-icon
              type="external-link"
              class="cg-mat-icon-link-right cg-color-digital-blue"
              [class.cg-disabled-link]="
                isImpersonator && !link.allowImpersonator
              "
              style="vertical-align: middle"
            ></cigna-icon>
          </a>
        </ng-template>
      </ng-container>

      <a
        class="util-user__link-item util-user__link-item--clickable"
        *ngIf="isMessageCenterEnabled"
        routerLink="/message-center"
        [attr.data-test-id]="'lnk-profile-nav-child-mcenter'"
        [cignaTrackClicks]="[
          'trackEventOther',
          'Message Center',
          'ac-NV002-Name Subnav',
          { prop20: 'nav-sub-utility' }
        ]"
        >Message Center</a
      >
    </div>
  </div>
</ng-template>
